{
  "Binary": "Binaire",
  "Calculation": "Calcul",
  "Compensation-Plan": "Plan de comp.",
  "Create-Account": "Créer un compte",
  "Dashboard": "Tableau de bord",
  "Document-Import": "Importation de documents",
  "Document-Registry": "Registre des documents",
  "Entire-Network": "Réseau entier",
  "Finance-Payouts": "Retraits",
  "Finance-Transactions": "Transactions",
  "Finance-Wallet-Balances": "Soldes des portefeuilles",
  "Finance-Wallet-Import": "Importation de portefeuilles",
  "Finance": "Finance",
  "Genealogy": "Généalogie",
  "Import-Tree": "Importer l'arbre",
  "Logs": "Journaux et rapports",
  "Logs-Activity-Log": "Journal d'activité",
  "Logs-Export-History": "Historique d'exportation",
  "Logs-Reports": "Rapports",
  "Manage-Accounts": "Gestion des comptes",
  "Manage-Accounts-Roles": "Rôles",
  "Manage-Accounts-Accounts": "Comptes",
  "Marketing-Activity": "Activité marketing",
  "Network": "Réseau",
  "Payment-system": "Système de paiement",
  "Profile": "Profil",
  "Reports": "Rapports",
  "Settings-Currencies": "Devises",
  "Settings-Events": "Événements",
  "Settings-Event-Settings": "Paramètres d'événements",
  "Settings-Wallets": "Portefeuilles",
  "Settings-Payout-Methods": "Méthodes de retrait",
  "Settings-Localization": "Localisation",
  "Settings-Preferences": "Préférences",
  "Settings-Profile-Fields": "Champs de profil",
  "Settings-Plan": "Paramètres du plan",
  "Settings": "Paramètres",
  "Visual-Binary": "Binaire visuel",
  "Visual-Genealogy": "Généalogie visuelle",
  "Visual-Tree": "Arbre visuel",
  "Wallet": "Portefeuilles",
  "Settings-Wallet-Transfer-Rules": "Configurer les règles de transfert de portefeuilles",
  "periodTypes": {
    "monthly": "Mensuel",
    "weekly": "Hebdomadaire",
    "daily": "Quotidien",
    "hourly": "Horaire",
    "quarterHourly": "Tous les 15 minutes",
    "yearly": "Annuel"
  }
}

